import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router'
import { successToast, errorToast } from "../../Utils/toast";
import { useCreateGotraMutation } from "../../redux/services/gotraService/gotra.Services";

function Addgotra() {

    const navigate = useNavigate();
    const [createState, { isLoading }] = useCreateGotraMutation();
    const [formData, setFormData] = useState({
        name: "",
        status: "active",
    });


    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

    };

    // SUBMIT
    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            const response = await createState(formData).unwrap();

            console.log(response);

            successToast("success", "State Created Successfully");



            navigate(-1);

        } catch (error) {

            console.log(error);

            errorToast("error", "Failed To Create State");

        }
    };

    return (

        <div>

            {/* HEADER */}
           <div className="dashboard-header">
    <div className="dashboard-header-inner">

        <div className="header-content">
            <span className="header-badge">
                Gotra Management
            </span>

            <h2 className="page-title">
                Add Gotra
            </h2>

            <div className="custom-breadcrumb">
                <Link to="/">Home</Link>
                <span>/</span>
                <span className="active">Add Gotra</span>
            </div>
        </div>

        <button
            onClick={() => navigate(-1)}
            className="btn btn-primary add-btn"
        >
            <i className="fe fe-arrow-left me-2"></i>
            Gotra List
        </button>

    </div>
</div>

            {/* FORM */}
            <div className="card">

                <div className="card-body">

                    <form onSubmit={handleSubmit}>

                        <div className="container">

                            <div className="row align-items-end">

                                {/* INPUT */}
                                <div className="col-md-6">

                                    <div className="form-group">

                                        <label>
                                            Enter Gotra
                                        </label>

                                        <input
                                            type="text"
                                            className='form-control custumform'
                                            placeholder='Enter Gotra Name'
                                            name="gotra_name"
                                            value={formData.gotra_name}
                                            onChange={handleChange}
                                        />

                                    </div>
                                    <div className="form-group mt-3">

                                        <label>Status</label>

                                        <select
                                            name="status"
                                            className="form-control"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >

                                            <option value="active">
                                                Active
                                            </option>

                                            <option value="inactive">
                                                Inactive
                                            </option>

                                        </select>

                                    </div>

                                </div>

                                {/* BUTTON */}
                                <div className="col-md-6">

                                    <div className="form-group">

                                        <div className="button_submit">

                                            <button
                                                type="submit"
                                                className='btn btn-primary'
                                            >

                                                {
                                                    isLoading
                                                        ? "Loading..."
                                                        : "Submit"
                                                }

                                            </button>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

        </div>
    )
}

export default Addgotra